import axiosInstance from './axiosInstance';

export async function getAllLoads(page = 1, limit = 10, status = '') {
  const response = await axiosInstance.get('/loads/get-all-loads.php', {
    params: { page, limit, status },
  });
  return response.data;
}

export async function createLoad(loadData) {
  const response = await axiosInstance.post('/loads/create-load.php', loadData);
  return response.data;
}

export async function getLoadDetail(id) {
  const response = await axiosInstance.get(`/loads/get-load-detail.php?id=${id}`);
  return response.data;
}

export async function assignDriver(loadId, driverId) {
  const response = await axiosInstance.post('/loads/assign-driver.php', {
    load_id: loadId,
    driver_id: driverId,
  });
  return response.data;
}




export async function editLoad(loadData) {
  const response = await axiosInstance.post('/loads/edit-load.php', loadData);
  return response.data;
}

export async function cancelLoad(loadId) {
  const response = await axiosInstance.post('/loads/cancel-load.php', { id_load: loadId });
  return response.data;
}






// loadsApi.js
export async function searchLoads(query, status = '') {
  const response = await axiosInstance.get('/loads/search-loads.php', {
    params: { q: query, status },
  });
  return response.data.loads || [];
}